import React from 'react'
import Avatar from 'material-ui-legacy/Avatar'
import Chip from 'material-ui-legacy/Chip'
import {
  purple100,
  purple500,
  deepPurple100,
  deepPurple500,
  green100,
  green500,
  red500,
  red100,
  amber200,
  amber500,
  lightBlue50,
  grey100,
  grey900
} from 'material-ui-legacy/styles/colors'

const deleteIconStyle = {margin: '0 2px -7px -5px', padding: '0'}
const chipStyle = {display: 'inline-block', height: '32px', margin: '2px'}

const Op = (props) => (
  <Chip
    style={{...chipStyle, ...props.style}}
    onRequestDelete={props.onRequestDelete}
    onClick={props.onClick}
    backgroundColor={amber200}
    deleteIconStyle={deleteIconStyle}
  >
    <Avatar backgroundColor={amber500} color="#000" size={32}>OP</Avatar>
    {props.value}
  </Chip>
)

const RawValue = (props) => (
  <Chip
    style={{...chipStyle, ...props.style}}
    onRequestDelete={props.onRequestDelete}
    onClick={props.onClick}
    backgroundColor={grey100}
    deleteIconStyle={deleteIconStyle}
  >
    {props.value}
  </Chip>
)

const DollarValue = (props) => (
  <Chip
    style={{...chipStyle, ...props.style}}
    onRequestDelete={props.onRequestDelete}
    onClick={props.onClick}
    backgroundColor={green100}
    deleteIconStyle={deleteIconStyle}
  >
    <Avatar backgroundColor={green500} color='#fff' size={32}>$</Avatar>
    {props.name ? `${props.name} = ` : ''}{props.value}
  </Chip>
)

const AddedPercentage = (props) => (
  <Chip
    style={{...chipStyle, ...props.style}}
    onRequestDelete={props.onRequestDelete}
    onClick={props.onClick}
    backgroundColor={green100}
    deleteIconStyle={deleteIconStyle}
  >
    <Avatar backgroundColor={green500} color='#fff' size={32}>+%</Avatar>
    {props.name ? `${props.name} = ` : ''}{props.value}
  </Chip>
)

const PercentageOf = (props) => (
  <Chip
    style={{...chipStyle, ...props.style}}
    onRequestDelete={props.onRequestDelete}
    onClick={props.onClick}
    backgroundColor={red100}
    deleteIconStyle={deleteIconStyle}
  >
    <Avatar backgroundColor={red500} color='#fff' size={32}>-%</Avatar>
    {props.name ? `${props.name} = ` : ''}{props.value}
  </Chip>
)

const CostFormula = (props) => (
  <Chip
    style={{...chipStyle, ...props.style}}
    onRequestDelete={props.onRequestDelete}
    onClick={props.onClick}
    backgroundColor={purple100}
    deleteIconStyle={deleteIconStyle}
  >
    <Avatar backgroundColor={purple500} color='#fff' size={32}>
      CF
    </Avatar>
    {props.name ? `${props.name} = ` : ''}{props.value}
  </Chip>
)

const RateFormula = (props) => (
  <Chip
    style={{...chipStyle, ...props.style}}
    onRequestDelete={props.onRequestDelete}
    onClick={props.onClick}
    backgroundColor={deepPurple100}
    deleteIconStyle={deleteIconStyle}
  >
    <Avatar backgroundColor={deepPurple500} color='#fff' size={32}>
      RF
    </Avatar>
    {props.name ? `${props.name} = ` : ''}{props.value}
  </Chip>
)

const Formula = (props) => (
  props.formulaType === 'cost' ?
  <CostFormula {...props} /> :
  <RateFormula {...props} />
)

const Result = (props) => (
  <Chip
    style={{...chipStyle, ...props.style}}
    onClick={props.onClick}
    backgroundColor={lightBlue50}
  >
    = {props.value}
  </Chip>
)

const ParseError = (props) => (
  <Chip
    style={{...chipStyle, ...props.style}}
    onClick={props.onClick}
    labelColor='#fff'
    backgroundColor={grey900}
  >
    = {props.value || 'Parsing error'}
  </Chip>
)

export {
  Op,
  RawValue,
  DollarValue,
  AddedPercentage,
  PercentageOf,
  CostFormula,
  RateFormula,
  Formula,
  Result,
  ParseError
}



// WEBPACK FOOTER //
// ./src/components/UI/FormulaTokens.jsx